import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as api from './api'

export const DOCUMENT_KIND = {
  DESPATCH: 'despatch',
  RECEIPT: 'receipt',
}

export const getDocument = createAsyncThunk('eDespatchAdvices/GET_DOCUMENT', async ({ documentId, kind }, thunkAPI) => {
  const fetcher = kind === DOCUMENT_KIND.RECEIPT ? api.getReceipt : api.getDespatch
  const { data, error } = await fetcher(documentId)
  if (error) return thunkAPI.rejectWithValue(error)
  return data
})

export const getActionHistory = createAsyncThunk(
  'eDespatchAdvices/GET_ACTION_HISTORY',
  async ({ documentId, documentType }, thunkAPI) => {
    const { data, error } = await api.getActions(documentId, documentType)
    if (error) return thunkAPI.rejectWithValue(error)
    return data
  },
)

const initialState = {
  document: null,
  isLoading: false,
  error: null,
  actions: null,
  isLoadingActions: false,
  actionsError: null,
}

export const slice = createSlice({
  name: 'eDespatchAdvices',
  initialState,
  reducers: {
    clearDocument: state => {
      state.document = null
      state.error = null
      state.actions = null
      state.actionsError = null
    },
  },
  extraReducers: builder =>
    builder
      .addCase(getDocument.pending, state => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getDocument.fulfilled, (state, action) => {
        state.isLoading = false
        state.document = action.payload
      })
      .addCase(getDocument.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload || action.error
      })
      .addCase(getActionHistory.pending, state => {
        state.isLoadingActions = true
        state.actionsError = null
      })
      .addCase(getActionHistory.fulfilled, (state, action) => {
        state.isLoadingActions = false
        state.actions = action.payload
      })
      .addCase(getActionHistory.rejected, (state, action) => {
        state.isLoadingActions = false
        state.actionsError = action.payload || action.error
      }),
})

export const { clearDocument } = slice.actions

export const documentSelector = state => state.eDespatchAdvices.document
export const isLoadingSelector = state => state.eDespatchAdvices.isLoading
export const errorSelector = state => state.eDespatchAdvices.error
export const actionsSelector = state => state.eDespatchAdvices.actions
export const isLoadingActionsSelector = state => state.eDespatchAdvices.isLoadingActions
export const actionsErrorSelector = state => state.eDespatchAdvices.actionsError

export const reducer = slice.reducer
